var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/65a6d567f9e0c0e2bed3e6fe96c48b88.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8c31b18859871e674415755507e8ad08.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    